import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes, faStore } from "@fortawesome/free-solid-svg-icons";

function Search({ filters, onSearchChange, onFilterSelect }) {
    const [filter_id, setFilterId] = useState('');
    const [query, setQuery] = useState('');

    useEffect(() => {
        if (filter_id !== undefined) {
            onFilterSelect(filter_id);
        }
    }, [filter_id]);

    const clearFilters = () => {
        setFilterId('');
        onFilterSelect('');
    };

    return (
        <div>
            {/* Hero banner */}
            <div
                className="w-full py-10 px-4 relative overflow-hidden"
                style={{ background: "linear-gradient(135deg, #0049a8 0%, #014E86 60%, #51A4A9 100%)" }}
            >
                {/* Decorative circles */}
                <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/5 rounded-full" />
                <div className="absolute bottom-0 -left-8 w-28 h-28 bg-white/5 rounded-full" />

                <div className="relative max-w-2xl mx-auto text-center">
                    <div className="inline-flex items-center justify-center w-12 h-12 bg-white/10 rounded-2xl mb-3">
                        <FontAwesomeIcon icon={faStore} className="text-white text-xl" />
                    </div>
                    <h1 className="text-2xl sm:text-3xl font-bold text-white mb-1">
                        Directorio de Emprendedores
                    </h1>
                    <p className="text-blue-200 text-sm mb-6">
                        Descubre los mejores vendedores de la plataforma
                    </p>

                    {/* Search input */}
                    <div className="relative">
                        <FontAwesomeIcon
                            icon={faSearch}
                            className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
                        />
                        <input
                            type="text"
                            value={query}
                            placeholder="Buscar por nombre..."
                            className="w-full pl-11 pr-4 py-3.5 rounded-2xl text-sm text-gray-700 bg-white shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all"
                            onChange={(e) => {
                                setQuery(e.target.value);
                                onSearchChange(e.target.value);
                            }}
                        />
                        {query && (
                            <button
                                onClick={() => { setQuery(''); onSearchChange(''); }}
                                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {/* Filter chips */}
            {filters && filters.length > 0 && (
                <div className="container pt-4 pb-2">
                    <div className="flex items-center justify-start gap-2 mb-3">
                        <h3 className="text-xs mb-0 font-semibold text-gray-400 uppercase tracking-wider">
                            Filtrar por región
                        </h3>
                        {filter_id && (
                            <button
                                onClick={clearFilters}
                                className="text-xs text-red-500 hover:text-red-600 flex items-center gap-2 transition-colors"
                            >
                                Limpiar <FontAwesomeIcon icon={faTimes} />
                            </button>
                        )}
                    </div>
                    <div className="flex flex-wrap gap-2">
                        {filters.map((filter) => {
                            const isSelected = filter_id === filter.id;
                            return (
                                <button
                                    key={filter.id}
                                    onClick={() => setFilterId(filter.id)}
                                    className={`
                                        px-4 py-1.5 rounded-full text-xs font-semibold transition-all duration-200 border
                                        ${isSelected
                                            ? "bg-ecoprimary1 text-white border-ecoprimary1 shadow-sm"
                                            : "bg-white text-gray-600 border-gray-200 hover:border-ecoprimary1 hover:text-ecoprimary1"
                                        }
                                    `}
                                >
                                    {filter.name}
                                </button>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}

export default Search;
